import React from 'react';
import CostingRunPage, { manufacturingCostingConfig } from '../shared/CostingRunPage';

// Manufacturing > Costing — runs the whole chain (implosion, procurement prices,
// finished-good cost) and shows the unit costs plus the run's exceptions.
// Shares CostingRunPage with Procurement > Costing.
const ManufacturingCosting = () => <CostingRunPage config={manufacturingCostingConfig} />;

export default ManufacturingCosting;
